import { mapState } from 'vuex';

import { PublicSettings } from '@/enums/publicSettings.enum';
import { renderMixin } from '@/mixins/render';

export const documentRenderMixin = {
  mixins: [renderMixin],
  computed: {
    ...mapState({
      viewId: state => state.setting.settings[PublicSettings.DOCUMENT_VIEW_ID]?.value,
      extraViewIds: state => {
        const value = state.setting.settings[PublicSettings.DOCUMENT_ATTACHMENT_VIEW_IDS]?.value;
        return value && JSON.parse(value);
      },
      documentRenderOptions: state => {
        const value = state.setting.settings[PublicSettings.DOCUMENT_RENDER_OPTIONS]?.value;
        return (value && JSON.parse(value)) || {};
      }
    }),
    renderUrl() {
      return this.getPdfURL(
        this.$route.params.documentId,
        this.viewId,
        this.extraViewIds,
        this.documentRenderOptions.landscape
      );
    },
    previewUrl() {
      return this.getPreviewURL(this.$route.params.documentId, this.viewId, this.extraViewIds);
    }
  }
};
